import { render, staticRenderFns } from "./LcaUpstreamTransportation.vue?vue&type=template&id=16f6e3b7"
import script from "./LcaUpstreamTransportation.vue?vue&type=script&lang=js"
export * from "./LcaUpstreamTransportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports